import { focusAsync, getDocument, getNextElement } from '@fluentui/react';

export function moveFocusToNextElement(element: HTMLElement | null): void {
    if (!element) {
        return;
    }

    const doc = getDocument();
    if (!doc) {
        return;
    }

    const nextElement = getNextElement(doc.body, element, false, false, true, true, false, false);
    if (nextElement !== null) {
        focusAsync(nextElement);
    }
}
